module.exports = __webpack_public_path__ + "img/vertical_4_1_9016.6e729ccf.png";